<template>
  <div class="com-product-item" @click="toDetail">
    <div class="product-item">
      <div style="position: relative">
        <img :src="productInfo.productImg?.split(',')[0] | formatFile" class="cover" alt="" />
        <div class="tag flex-xy-center" :style="{ background: `url(${currentTag.bg})` }">
          <img :src="currentTag.icon" class="tag-icon" alt="" />
          <span>{{ currentTag.name }}</span>
        </div>
      </div>
      <div class="bottom-info">
        <div class="name  elliPsis">
          <el-tooltip class="item elliPsis" effect="dark" placement="top">
            <template #content>
              <span>{{ productInfo.productTitle }}</span>
            </template>
            <div>{{ productInfo.productTitle }}</div>
          </el-tooltip>
        </div>
        <div class="desc  elliPsis">
          <el-tooltip class="item" effect="dark" placement="top">
            <template #content>
              <span>{{ productInfo.createTime }} ｜ {{ productInfo.province }} {{ productInfo.city }}</span>
            </template>
            <span>{{ productInfo.createTime.split(" ")[0] }} ｜ {{ productInfo.province }} {{ productInfo.city }}</span>
          </el-tooltip>
        </div>
        <div class="price">
          <div class="">
            <span class="price" v-if="productInfo.showPrice != 0"> {{ productInfo.showPrice | formatMoney }}</span>
            <span class="price" v-else> 询价</span>
            <span style="color: #333; font-size: 28rpx; font-weight: normal"
              v-if="productInfo.putType == 3 && productInfo.showPrice != 0">/月</span>
          </div>
        </div>
        <span v-if="productInfo.isVerify == 1" class="veriFy">
          <img src="@/assets/img/ischeck.png" style="width: 70px;" alt="">
        </span>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "ProductItem",
  props: {
    productInfo: {
      default: {},
    },
    id: {
      default: '',
    },
    yourfilters: {
      default: {},
    },
    link: {
      default: false
    },
    iframe: {
      default: '',
    },
  },

  data() {
    return {
      tags: [
        {
          type: 1,
          name: "厂家",
          icon: require("@/assets/img/icon-type-1.png"),
          bg: require("@/assets/img/icon-type-1-bg.png"),
        },
        {
          type: 2,
          name: "二手",
          icon: require("@/assets/img/icon-type-2.png"),
          bg: require("@/assets/img/icon-type-2-bg.png"),
        },
        {
          type: 3,
          name: "租赁",
          icon: require("@/assets/img/icon-type-3.png"),
          bg: require("@/assets/img/icon-type-3-bg.png"),
        },
      ],
    };
  },
  computed: {
    currentTag() {
      return this.tags.find((item) => item.type == this.productInfo.putType);
    },
  },
  created() {
    console.log(this.productInfo, 'productInfo');

  },
  methods: {
    toDetail() {
      if (this.link) return this.$emit('link', this.productInfo)
      // this.$router.push("/productDetail/" + this.$route.name + '?id=' + this.id);
      this.$router.push({
        path: "/productDetail/" + this.$route.name,
        query: {
          id: this.id,
          filters: JSON.stringify(this.yourfilters) // 序列化对象
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.veriFy {
  position: absolute;
  right: 10px;
  bottom: 5px;
}

.elliPsis {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.com-product-item {
  margin-right: 13px;
  width: 229px;
  cursor: pointer;
}

.product-item {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;

  .cover {
    width: 100%;
    height: 229.6px;
  }

  .tag {
    position: absolute;
    top: 10px;
    left: -2px;
    width: 60px;
    height: 28px;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;

    .tag-icon {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }

  .bottom-info {
    background: #fff;
    padding: 15px 15px 0 15px;

    .name {
      font-weight: 400;
      font-size: 18px;
      color: #333333;
    }

    .desc {
      font-weight: 400;
      font-size: 16px;
      color: #808080;
      margin: 12px 0;
    }

    .price {
      font-weight: bold;
      font-size: 18px;
      color: #f42d1f;
      padding-bottom: 16px;
    }
  }
}
</style>
